module.exports = __webpack_public_path__ + "static/media/brush--green.f7e5ee23.svg";